(function (angular, schoolwork12) {
    'use strict';
    
    angular.module(schoolwork12.app.common.name).factory(schoolwork12.app.common.services.eventNotification, 
        ['$rootScope',
         '$timeout',
        function ($rootScope, $timeout) {
           
            var subscribe = function (eventName, callback) {
                console.info('subscribe: '.concat(eventName));
                    return $rootScope.$on(eventName, callback);
                },

                broadcast = function (eventName, data) {
                    // console.info('broadcast: '.concat(eventName).concat(' ').concat(data.username));
                   $timeout(function(){
                            $rootScope.$emit(eventName, data);
                        }, 200);
                };

            return {
                subscribe: subscribe,
                broadcast: broadcast
            };
        }
    ]);
}(angular, schoolwork12));
